import React from "react";
import "../TechnologyConsulting.css";
import techbanner from "../../assets/banner-2.jfif"; 


import {
  FaRoute,
  FaSyncAlt,
  FaCloud,
  FaRobot,
  FaProjectDiagram,
  FaCogs,
  FaArrowRight,
} from "react-icons/fa";

const consulting = [
  {
    icon: <FaRoute />,
    title: "Technology Roadmap",
    description:
      "Create a clear technology strategy aligned with your business goals and long-term growth.",
  },
  {
    icon: <FaSyncAlt />,
    title: "Digital Transformation",
    description:
      "Modernize business processes and adopt innovative technologies to improve productivity.",
  },
  {
    icon: <FaCloud />,
    title: "Cloud Strategy",
    description:
      "Design scalable cloud solutions, migration plans, and secure cloud infrastructures.",
  },
  {
    icon: <FaRobot />,
    title: "Process Automation",
    description:
      "Automate repetitive workflows using AI and intelligent business automation solutions.",
  },
  {
    icon: <FaProjectDiagram />,
    title: "Architecture Consulting",
    description:
      "Build scalable, secure, and future-ready software architectures for enterprise applications.",
  },
  {
    icon: <FaCogs />,
    title: "Software Modernization",
    description:
      "Upgrade legacy systems with modern technologies for better performance and scalability.",
  },
];

const TechnologyConsulting = () => {
  return (
    <section className="consulting">

      <div className="consulting-container">

        {/* LEFT */}

        <div className="consulting-content">

          <span className="section-tag">
            TECHNOLOGY CONSULTING
          </span>

          <h2>
            Strategic IT Consulting for
            <span> Business Growth</span>
          </h2>

          <p className="consulting-intro">
            At VisionVote Technologies, we help organizations navigate
            digital transformation with confidence. Our consulting
            services empower businesses to adopt the right technologies,
            optimize operations, and build scalable digital ecosystems
            that drive long-term success.
          </p>

          <div className="consulting-list">

            {consulting.map((item, index) => (
              <div className="consulting-item" key={index}>

                <div className="consulting-icon">
                  {item.icon}
                </div>

                <div>

                  <h3>{item.title}</h3>

                  <p>{item.description}</p>

                </div>

              </div>
            ))}

          </div>

          {/* <button className="consulting-btn">
            Schedule a Consultation
            <FaArrowRight />
          </button> */}

        </div>

        {/* RIGHT */}

        <div className="consulting-image">

          <img
            src={techbanner}
            alt="Technology Consulting"
          />

          <div className="floating-card top">
            📈 Business Strategy
          </div>

          <div className="floating-card middle">
            ☁️ Cloud Solutions
          </div>

          <div className="floating-card bottom">
            🤖 AI Consulting
          </div>

        </div>

      </div>

    </section>
  );
};

export default TechnologyConsulting;